<template>
  <div class="home-page">
    <section class="hero">
      <p class="hero-label">Acqtion · Acquisition Consultants</p>
      <h1>Uw ervaren partner in overnames, financieel advies en <em>strategische groei.</em></h1>
      <p class="hero-subtitle">Onafhankelijk, discreet en persoonlijk. Al meer dan 25 jaar begeleiden wij ondernemers bij de belangrijkste financiële beslissingen van hun leven.</p>
      <div class="hero-buttons">
        <router-link to="/contact" class="btn-primary">Plan een gesprek <span>→</span></router-link>
      </div>
    </section>

    <div class="stats-bar">
      <div class="stat-item">
        <div class="stat-number">100+</div>
        <div class="stat-label">Gerealiseerde transacties</div>
      </div>
      <div class="stat-item">
        <div class="stat-number">25+</div>
        <div class="stat-label">Jaar ervaring</div>
      </div>
      <div class="stat-item">
        <div class="stat-number">0,5–5M</div>
        <div class="stat-label">Gem. transactiewaarde</div>
      </div>
    </div>

    <section class="section-white">
      <p class="section-label">Onze diensten</p>
      <h2 class="section-title">Eén partner voor elke financiële mijlpaal in uw onderneming.</h2>
      <p class="section-text">Of u nu een bedrijf wilt kopen, verkopen of uw financiële sturing wilt professionaliseren: bij Acqtion vindt u een ervaren partner die meedenkt, meewerkt en resultaat levert.</p>

      <div class="pillars-grid">
        <div class="pillar-card">
          <div class="pillar-icon"></div>
          <h3>Fusies &amp; Overnames</h3>
          <p>Een bedrijf kopen of verkopen is een van de meest ingrijpende beslissingen voor een ondernemer. Wij begeleiden het volledige proces, van de eerste waardering tot de handtekeningen in de verkoopsovereenkomst. Discreet, onafhankelijk en met oog voor elke nuance.</p>
          <router-link to="/fusies-en-overnames" class="pillar-link">Meer over M&A <span>→</span></router-link>
        </div>
        <div class="pillar-card">
          <div class="pillar-icon"></div>
          <h3>Financieel Advies</h3>
          <p>Van een gedetailleerd ondernemingsplan tot budgettering en waarderingen: wij leveren financieel advies dat onderbouwd, onafhankelijk en direct toepasbaar is. Uw cijfers worden een kompas in plaats van een raadsel.</p>
          <router-link to="/financieel-advies" class="pillar-link">Meer over advies <span>→</span></router-link>
        </div>
        <div class="pillar-card">
          <div class="pillar-badge">Nieuw</div>
          <div class="pillar-icon"></div>
          <h3>CFO as a Service</h3>
          <p>Topniveau financieel inzicht, zonder de fulltime loonkost. Een ervaren financieel directeur die zich volledig verdiept in uw bedrijf. Flexibel, schaalbaar en direct inzetbaar. Eén vast aanspreekpunt, 100% commitment.</p>
          <router-link to="/cfo-as-a-service" class="pillar-link">Ontdek CFO as a Service <span>→</span></router-link>
        </div>
      </div>
    </section>

    <section class="section-dark">
      <div class="values-grid">
        <div>
          <p class="section-label">Onze waarden</p>
          <h2 class="section-title">Onafhankelijk advies. Persoonlijke aanpak. Meetbaar resultaat.</h2>
        </div>
        <div class="values-list">
          <div class="value-item">
            <h4>Maximale discretie</h4>
            <p>Vertrouwelijkheid is onze basisregel. Altijd, naar alle partijen. Uw dossier is in veilige handen.</p>
          </div>
          <div class="value-item">
            <h4>Het vierogenprincipe</h4>
            <p>Elk advies wordt voorgelegd aan gespecialiseerde interne of externe partijen. Zo garanderen we kwaliteit en objectiviteit.</p>
          </div>
          <div class="value-item">
            <h4>Persoonlijke betrokkenheid</h4>
            <p>U werkt met één vast aanspreekpunt dat uw dossier door en door kent. Geen wisselende consultants, maar een partner die er écht in investeert.</p>
          </div>
          <div class="value-item">
            <h4>Resultaat, geen theorie</h4>
            <p>Wij leveren concrete oplossingen en haalbare actieplannen. Geen dikke rapporten die in een lade belanden.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section-warm">
      <div class="cfo-highlight">
        <div class="cfo-content">
          <p class="section-label">CFO as a Service</p>
          <h2 class="section-title">Het gat tussen uw boekhouder en uw groeiambities.</h2>
          <p>Uw boekhouder is onmisbaar voor het verleden. Maar als ondernemer leeft u in de toekomst. Wie helpt u met vooruitkijken? Veel KMO's hebben behoefte aan strategische financiële sturing, maar voor een fulltime CFO is het vaak nog te vroeg. Of te duur.</p>
          <p><strong>CFO as a Service is het antwoord.</strong> Een doorgewinterde financieel directeur die zich volledig verdiept in uw bedrijf. Die eigenaarschap neemt over de cijfers, de pijnpunten blootlegt en met een concreet actieplan komt.</p>
          <div class="cfo-cta-wrap">
            <router-link to="/cfo-as-a-service" class="btn-primary">Meer over CFO as a Service <span>→</span></router-link>
          </div>
        </div>
        <div class="cfo-visual">
          <p class="cfo-visual-label">Wat u kunt verwachten</p>
          <p class="cfo-quote">Eén vast aanspreekpunt. Volledig ingewerkt. Direct inzetbaar.</p>
          <ul class="cfo-checklist">
            <li>Cashflow management &amp; prognoses</li>
            <li>Strategische rapportering &amp; BI-dashboards</li>
            <li>Financiering &amp; bankrelaties</li>
            <li>Stakeholder management</li>
            <li>On-site aanwezigheid indien gewenst</li>
            <li>Flexibele vergoeding: uur-, dag- of projecttarief</li>
          </ul>
        </div>
      </div>
    </section>

    <section class="cta-section">
      <p class="section-label">Laten we kennismaken</p>
      <h2 class="section-title">Een overname, waardering of financieel vraagstuk? We luisteren graag.</h2>
      <p class="section-text">Plan een vrijblijvend en vertrouwelijk gesprek. Samen bekijken we hoe Acqtion waarde kan toevoegen aan uw onderneming.</p>
      <router-link to="/contact" class="cta-button">Neem contact op <span>→</span></router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>
.home-page {
  box-sizing: border-box;
}

.hero {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 100px 6% 56px;
  position: relative;
  overflow: hidden;
  background: #f5f2ee;
}

.hero::before {
  content: '';
  position: absolute;
  top: -10%;
  right: -5%;
  width: 700px;
  height: 700px;
  background: radial-gradient(circle, rgba(123,155,49,0.06) 0%, transparent 65%);
  border-radius: 50%;
  pointer-events: none;
}

.hero::after {
  content: '';
  position: absolute;
  bottom: -20%;
  left: -10%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(97,120,143,0.04) 0%, transparent 65%);
  border-radius: 50%;
  pointer-events: none;
}

.hero-label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 3.5px;
  text-transform: uppercase;
  color: #61788F;
  margin-bottom: 28px;
  opacity: 0;
  animation: fadeUp 0.8s ease forwards 0.3s;
}

.hero h1 {
  font-family: 'DM Serif Display', serif;
  font-size: clamp(2.6rem, 6vw, 4.5rem);
  line-height: 1.1;
  max-width: 800px;
  margin-bottom: 32px;
  color: #2a2f35;
  opacity: 0;
  animation: fadeUp 0.8s ease forwards 0.5s;
}

.hero h1 em { font-style: italic; color: #7B9B31; }

.hero-subtitle {
  font-size: 1.2rem;
  max-width: 560px;
  color: #6b6b7b;
  margin-bottom: 48px;
  opacity: 0;
  animation: fadeUp 0.8s ease forwards 0.7s;
}

.hero-buttons {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  opacity: 0;
  animation: fadeUp 0.8s ease forwards 0.9s;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #2a2f35;
  color: #fff;
  padding: 17px 36px;
  font-size: 0.88rem;
  font-weight: 500;
  text-decoration: none;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.btn-primary:hover { background: #7B9B31; transform: translateY(-2px); }

.stats-bar {
  display: flex;
  border-top: 1px solid rgba(42,47,53,0.08);
  border-bottom: 1px solid rgba(42,47,53,0.08);
  background: #fff;
}

.stat-item {
  flex: 1;
  padding: 32px 6%;
  text-align: center;
  border-right: 1px solid rgba(42,47,53,0.08);
}

.stat-item:last-child { border-right: none; }

.stat-number {
  font-family: 'DM Serif Display', serif;
  font-size: 2.8rem;
  color: #2a2f35;
  line-height: 1;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 0.82rem;
  color: #6b6b7b;
  font-weight: 400;
  letter-spacing: 0.5px;
}

.section-warm { padding: 56px 6%; background: #f5f2ee; color: #2a2f35; }
.section-white { padding: 56px 6%; background: #fff; color: #2a2f35; }
.section-dark { padding: 56px 6%; background: #2a2f35; color: #fff; }

.section-label {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #7B9B31;
  margin-bottom: 20px;
}

.section-title {
  font-family: 'DM Serif Display', serif;
  font-size: clamp(1.8rem, 3.5vw, 2.5rem);
  line-height: 1.25;
  max-width: 620px;
  margin-bottom: 20px;
}

.section-text {
  font-size: 1.05rem;
  color: #6b6b7b;
  max-width: 580px;
  margin-bottom: 28px;
}

.section-dark .section-text { color: rgba(255,255,255,0.55); }
.section-dark .section-title { color: #fff; }

.pillars-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  margin-top: 36px;
}

.pillar-card {
  padding: 32px 28px;
  background: #f5f2ee;
  border: 1px solid rgba(42,47,53,0.08);
  border-radius: 4px;
  position: relative;
  transition: all 0.35s ease;
  display: flex;
  flex-direction: column;
}

.pillar-card:hover {
  border-color: #7B9B31;
  transform: translateY(-6px);
  box-shadow: 0 20px 60px rgba(42,47,53,0.06);
}

.pillar-icon {
  width: 44px;
  height: 2px;
  background: #7B9B31;
  margin-bottom: 32px;
}

.pillar-badge {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #7B9B31;
  background: rgba(123,155,49,0.1);
  padding: 5px 12px;
  border-radius: 2px;
  margin-bottom: 20px;
}

.pillar-card h3 {
  font-family: 'DM Serif Display', serif;
  font-size: 1.3rem;
  margin-bottom: 14px;
  line-height: 1.3;
}

.pillar-card p {
  font-size: 0.92rem;
  color: #6b6b7b;
  margin-bottom: 28px;
  flex-grow: 1;
}

.pillar-link {
  font-size: 0.82rem;
  font-weight: 600;
  color: #2a2f35;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: color 0.3s ease;
}

.pillar-link:hover { color: #7B9B31; }
.pillar-link span { transition: transform 0.3s ease; }
.pillar-link:hover span { transform: translateX(4px); }

.values-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 72px;
  align-items: start;
}

.values-list { display: flex; flex-direction: column; gap: 0; }

.value-item {
  padding: 32px 0;
  border-top: 1px solid rgba(255,255,255,0.07);
}

.value-item h4 {
  font-family: 'DM Serif Display', serif;
  font-size: 1.1rem;
  color: #fff;
  margin-bottom: 8px;
}

.value-item p { font-size: 0.88rem; color: rgba(255,255,255,0.85); }

.cfo-highlight {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 72px;
  align-items: center;
}

.cfo-content p { font-size: 1.05rem; color: #6b6b7b; margin-bottom: 20px; }
.cfo-content p strong { color: #2a2f35; font-weight: 500; }

.cfo-cta-wrap { margin-top: 32px; }

.cfo-visual {
  background: #2a2f35;
  border-radius: 4px;
  padding: 40px 36px;
  position: relative;
  overflow: hidden;
}

.cfo-visual::before {
  content: '';
  position: absolute;
  top: -30%;
  right: -20%;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(123,155,49,0.12) 0%, transparent 70%);
  border-radius: 50%;
}

.cfo-visual-label {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #7B9B31;
  margin-bottom: 24px;
  position: relative;
}

.cfo-quote {
  font-family: 'DM Serif Display', serif;
  font-size: 1.5rem;
  color: #fff;
  line-height: 1.4;
  margin-bottom: 28px;
  position: relative;
}

.cfo-checklist {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: relative;
}

.cfo-checklist li {
  font-size: 0.88rem;
  color: rgba(255,255,255,0.55);
  padding-left: 20px;
  position: relative;
}

.cfo-checklist li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  width: 6px;
  height: 6px;
  background: #7B9B31;
  border-radius: 50%;
}

.cfo-checklist li { color: rgba(255,255,255,0.85); }

.cta-section {
  text-align: center;
  padding: 72px 6%;
  background: #2a2f35;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(123,155,49,0.06) 0%, transparent 60%);
  border-radius: 50%;
  pointer-events: none;
}

.cta-section .section-title { max-width: 540px; margin: 0 auto 16px; position: relative; }
.cta-section .section-text { margin: 0 auto 28px; color: rgba(255,255,255,0.85); position: relative; }
.cta-section .section-label { position: relative; }

.cta-button {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #7B9B31;
  color: #fff;
  padding: 18px 46px;
  font-size: 0.95rem;
  font-weight: 500;
  text-decoration: none;
  border-radius: 2px;
  transition: all 0.3s ease;
  position: relative;
}

.cta-button:hover { background: #8daf3a; transform: translateY(-2px); }

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 1000px) {
  .pillars-grid { grid-template-columns: 1fr; }
  .cfo-highlight { grid-template-columns: 1fr; }
  .values-grid { grid-template-columns: 1fr; gap: 32px; }
  .stats-bar { flex-direction: column; }
  .stat-item { border-right: none; border-bottom: 1px solid rgba(42,47,53,0.08); }
  .stat-item:last-child { border-bottom: none; }
}

@media (max-width: 768px) {
  .section-warm, .section-white, .section-dark { padding: 48px 5%; }
  .hero { padding: 80px 5% 40px; }
  .hero-buttons { flex-direction: column; }
  .btn-primary { text-align: center; justify-content: center; }
}
</style>
